export enum WeaponType {
    Rifle = 'rifle',
    Pistol = 'pistol',
    Fist = 'unarmed'
}
